import BaseComponent from "../../../../../lib/components/BaseComponent";
import VerticalLayout from "../../../../../lib/components/layouts/VerticalLayout";


class BarChartTest extends BaseComponent {

  render() {
    return <VerticalLayout className='p-20 sandbox-container flex flex-col gap-4'>
      <div className={'max-h-80 w-full bg-cn-color-black p-5 flex justify-center'}>
      </div>
    </VerticalLayout>
  }
}

export default BarChartTest;
